module.exports = __webpack_public_path__ + "static/media/logo.ab03f7a6.jpg";